import { render, staticRenderFns } from "./QueueBusterNew.vue?vue&type=template&id=983d6858"
import script from "./QueueBusterNew.vue?vue&type=script&lang=js"
export * from "./QueueBusterNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports